import { render, staticRenderFns } from "./CategoryPanel.vue?vue&type=template&id=e94fd43e&scoped=true&"
import script from "./CategoryPanel.vue?vue&type=script&lang=js&"
export * from "./CategoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPanel.vue?vue&type=style&index=0&id=e94fd43e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94fd43e",
  null
  
)

export default component.exports